

import {
    Language
} from "../screens/language";
import {
    Instructions
} from "../screens/instructions";
import {
    AddressVerification
} from "../screens/addressVerification";
import {
    Documents
} from "../screens/documents";
import {
    Selfie
} from "../screens/selfie";
import {
    IdProof
} from "../screens/idProof";
import {
    AddressProof
} from "../screens/addressProof";
import {
    RelationshipProof
} from "../screens/relationshipProof";
import {
    HomeImage
} from "../screens/homeImage";
import {
    Video
} from "../screens/video";
import {
    IDPhoto
} from '../screens/idPhoto'
import {
    Preview
} from '../screens/preview'
import Thankyou from '../screens/thankyou'


export const publicRoutes = [
    {
        path: "/",
        name: "language",
        label: 'Language',
        icon: '',
        component: Language,
        route: "public"
    },
    {
        path: "/language",
        name: "language",
        label: 'Language',
        icon: '',
        component: Language,
        route: "public"
    },
    {
        path: "/instructions",
        name: "instructions",
        label: 'Instructions',
        icon: '',
        component: Instructions,
        route: "public"
    },
    {
        path: "/addressVerification",
        name: "addressVerification",
        label: 'Address Verification',
        icon: '',
        component: AddressVerification,
        route: "public"
    },
    {
        path: "/documents",
        name: "documents",
        label: 'Documents',
        icon: '',
        component: Documents,
        route: "public"
    },
    {
        path: "/selfie",
        name: "selfie",
        label: 'Selfie',
        icon: '',
        component: Selfie,
        route: "public"
    },
    {
        path: "/idProof",
        name: "idProof",
        label: 'Id Proof',
        icon: '',
        component: IdProof,
        route: "public"
    },
    {
        path: "/idPhoto",
        name: "idPhoto",
        label: 'Id Photo',
        icon: '',
        component: IDPhoto,
        route: "public"
    },
    {
        path: "/addressProof",
        name: "addressProof",
        label: 'Address Proof',
        icon: '',
        component: AddressProof,
        route: "public"
    },
    {
        path: "/homeImage",
        name: "homeImage",
        label: 'Home Image',
        icon: '',
        component: HomeImage,
        route: "public"
    },
    {
        path: "/relationshipProof",
        name: "relationshipProof",
        label: 'Relationship Proof',
        icon: '',
        component: RelationshipProof,
        route: "public"
    },
    {
        path: "/video",
        name: "video",
        label: 'Video',
        icon: '',
        component: Video,
        route: "public"
    },
    {
        path: "/preview",
        name: "preview",
        label: 'Preview',
        icon: '',
        component: Preview,
        route: "public"
    },
    {
        path: "/thankyou",
        name: "thankyou",
        label: 'Thankyou',
        icon: '',
        component: Thankyou,
        route: "public"
    }
];

